import React from 'react';
import { Crown } from 'lucide-react';

/**
 * AppHeader - Main application header component
 * Shows logo, user info, pricing button, and admin access
 */
function AppHeader({ 
  user, 
  authUser, 
  isAuthenticated, 
  subscription, 
  onLogoClick, 
  onProfileClick, 
  onPricingClick, 
  onAdminClick,
  appVersion 
}) {
  return (
    <header className="bg-white border-b sticky top-0 z-50 px-6 py-4">
      <div className="max-w-7xl mx-auto flex justify-between items-center">
        {/* Logo */}
        <div 
          className="flex items-center gap-3 cursor-pointer" 
          onClick={onLogoClick}
          data-testid="header-logo"
        >
          <img 
            src="/logo.png" 
            alt="הצ'ייסר" 
            className="h-10 object-contain select-none pointer-events-none"
            draggable="false"
            onContextMenu={(e) => e.preventDefault()}
          />
        </div>
        
        <div className="flex items-center gap-4">
          {/* User Info / Profile (if Google auth) */}
          {isAuthenticated && authUser && (
            <button 
              onClick={onProfileClick}
              className="flex items-center gap-2 hover:bg-slate-100 px-2 py-1 rounded-lg transition-colors"
              data-testid="profile-button"
            >
              {authUser.picture ? (
                <img 
                  src={authUser.picture} 
                  alt={authUser.name} 
                  className="w-8 h-8 rounded-full border-2 border-teal-500"
                />
              ) : (
                <div className="w-8 h-8 rounded-full bg-teal-500 flex items-center justify-center text-white font-bold">
                  {authUser.name?.charAt(0) || 'U'}
                </div>
              )}
              <span className="text-sm font-medium text-slate-700 hidden md:block">
                {authUser.name}
              </span>
            </button>
          )}
          
          {/* Pricing Button */}
          <button
            onClick={onPricingClick}
            className="bg-gradient-to-r from-purple-600 to-pink-600 text-white px-4 py-2 rounded-xl text-sm font-bold hover:opacity-90 transition-opacity flex items-center gap-2"
            data-testid="pricing-button"
          >
            <Crown className="w-4 h-4" />
            {subscription?.type === 'trial' 
              ? `${subscription.daysLeft} ימים נותרו` 
              : subscription?.type 
                ? 'המנוי שלי' 
                : '21 יום חינם'}
          </button>
          
          {/* Admin Button */}
          <button
            onClick={onAdminClick}
            className="text-xs font-bold text-slate-400 hover:text-teal-500 transition-colors"
            title="פאנל ניהול"
            data-testid="admin-button"
          >
            ⚙️ ניהול
          </button>
          
          {/* Version */}
          <span className="text-xs font-bold text-slate-400">v{appVersion}</span>
        </div>
      </div>
    </header>
  );
}

export default AppHeader;
